import { Button } from "@/components/ui/button";
import {
  Dialog as UiDialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import Icon from "./Icon";
import { cn } from "@/lib/utils";

interface DialogProps {
  showBttn?: boolean;
  showHeader?: boolean;
  titleBttn?: string;
  iconBttn?: string;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  title: string;
  description: string;
  open?: boolean;
  className?: string;
  classNameContent?: string;
  onOpenChange?: (open: boolean) => void;
}

const Dialog: React.FC<DialogProps> = ({
  showBttn = true,
  showHeader = true,
  titleBttn,
  iconBttn,
  children,
  footer,
  title,
  description,
  open,
  className,
  classNameContent,
  onOpenChange,
}) => {
  return (
    <UiDialog open={open} onOpenChange={onOpenChange}>
      {showBttn && (
        <DialogTrigger asChild>
          <Button
            variant="ghost"
            className="flex justify-start gap-2 p-2 items-baseline w-full h-fit"
          >
            <Icon name={iconBttn || "circle-x"} className="w-3 h-3" />
            <p>{titleBttn || "Abrir Modal"}</p>
          </Button>
        </DialogTrigger>
      )}
      <DialogContent
        className={cn(
          "sm:max-w-[90vw] max-h-[85vh] p-4 pr-0 overflow-hidden max-w-11/12",
          className,
        )}
        onOpenAutoFocus={(e) => e.preventDefault()}
        onCloseAutoFocus={(e) => e.preventDefault()}
      >
        <DialogHeader className="w-11/12 pr-2 md:w-full">
          <DialogTitle className={`${!showHeader && "hidden"}`}>
            {title}
          </DialogTitle>
          <DialogDescription className={`${!showHeader && "hidden"}`}>
            {description}
          </DialogDescription>
        </DialogHeader>
        <div
          className={cn(
            `${footer ? "max-h-[65vh]" : "h-[80vh]"} overflow-y-auto pr-4 ${showHeader && !footer && "pb-20"}`,
            classNameContent,
          )}
        >
          {children}
        </div>
        {footer && (
          <DialogFooter className="pr-4 pt-4 border-t">
            {footer}
          </DialogFooter>
        )}
      </DialogContent>
    </UiDialog>
  );
};

export default Dialog;
